module.exports = __webpack_public_path__ + "img/map_catanzaro.adfa1aeb.png";